import axios from "axios";
import {API_URL} from "../config";

export const getSalesByLocationService = async (data) => {
    return axios.get(`${API_URL}/sales_by_location`, {
        params: {...data}
    });
}

export const getSalesOverTimeService = async (data) => {
    return axios.get(`${API_URL}/sales_over_time`, {
        params: {...data}
    });
}

export const getSalesByDoctorService = async (data) => {
    return axios.get(`${API_URL}/sales_by_doctor`, {
        params: {...data}
    });
}

export const getSalesByProductService = async (data) => {
    return axios.get(`${API_URL}/sales_by_product`, {
        params: {...data}
    });
}

export const getNewPatientsCountService = async (data) => {
    return axios.get(`${API_URL}/new_patients_count`, {
        params: {...data}
    });
}

export const getPatientsCountService = async (data) => {
    return axios.get(`${API_URL}/patients_count`, {
        params: {...data}
    });
}

export const getPatientsWhoPurchasedCountService = async (data) => {
    return axios.get(`${API_URL}/patient_purchases_count`, {
        params: {...data}
    });
}
